import moment from "moment-timezone";
import { changeDateToUtcString } from "../../../utils/helpers/text";

export const getTimelineBoundsFromPageEvent = (event) => ({
  timelineStartDay: event?.firstDay?.toISOString?.(),
  timelineEndDay: event?.lastDay?.toISOString?.(),
});

export const shouldSkipStandardPageLoading = ({
  isDateChangeInProgress,
  isSlotUpdateInProgress,
}) => {
  return isDateChangeInProgress || isSlotUpdateInProgress;
};

export const shouldLoadLatestEventDetails = ({
  newEquipmentIds = [],
  selectedEndDate,
  selectedStartDate,
}) => {
  return (
    newEquipmentIds.length > 0 &&
    Boolean(selectedEndDate) &&
    Boolean(selectedStartDate)
  );
};

export const getLatestEventDetailsStartDate = ({
  isOngoing,
  isEditMode,
  siteTimezone,
  originalSelectedStartDate,
  selectedStartDate,
}) => {
  if (isOngoing && isEditMode) {
    return moment.tz(siteTimezone).startOf("hour").utc().format();
  }

  return changeDateToUtcString(originalSelectedStartDate ?? selectedStartDate);
};

export const buildStandardPageEvents = ({
  reservationData = [],
  pendingReservations = [],
}) => {
  const mergedReservations = mergeReservationsWithPending({
    reservationData,
    pendingReservations,
  });

  return buildEventListWithUserPendingPriority({
    mergedReservations,
    pendingReservations,
  });
};

export const shouldSyncDatePickerFromPendingReservations = ({
  selectedStartDate,
  selectedEndDate,
  pendingReservations,
}) => {
  return (
    (!selectedStartDate || !selectedEndDate) &&
    Array.isArray(pendingReservations) &&
    pendingReservations.length > 0
  );
};

export const mergeTimelineReservations = ({ prevEvents = [], reservationData = [] }) => {
  const existingEventIds = new Set(prevEvents.map((event) => event.id));
  const newEvents = reservationData.filter((event) => !existingEventIds.has(event.id));
  return [...prevEvents, ...newEvents];
};

export const mergeReservationsWithPending = ({
  reservationData = [],
  pendingReservations = [],
}) => {
  return Array.from(
    new Map(
      [...reservationData, ...pendingReservations].map((item) => {
        const key = [
          item.bookingId,
          item.id,
          item.resource,
          item.equipment?.inventoryId ?? "",
        ].join("|");
        return [key, item];
      })
    ).values()
  );
};

export const buildEventListWithUserPendingPriority = ({
  mergedReservations = [],
  pendingReservations = [],
}) => {
  const userEvents = pendingReservations.filter(
    (event) => event.id && event.id.startsWith("available_"),
  );
  const serverEvents = mergedReservations.filter(
    (event) => !event.id || !event.id.startsWith("available_"),
  );

  return [...userEvents, ...serverEvents];
};
